<template>
  <div class="barcode-scanner fill-height">
    <div ref="video" class="video" />
  </div>
</template>

<script>
import Quagga from 'quagga'

export default {
    props: {
        confirmsNeeded: {
            type: Number,
            required: false,
            default: 5,
        },
    },
    data () {
        return {
            lastDetected: null,
            lastDetectedConfirms: 0,
            confirmed: false,
        }
    },
    methods: {
        onDetected (result) {
            const detected = {
                code: result.codeResult.code,
                format: result.codeResult.format,
            }

            if (this.lastDetected && this.lastDetected.code !== detected.code) {
                this.lastDetected = detected
                this.lastDetectedConfirms = 0
                return
            }

            this.lastDetected = detected
            this.lastDetectedConfirms++

            detected.confirms = this.lastDetectedConfirms
            this.$emit('detected', detected)

            if (this.lastDetectedConfirms < this.confirmsNeeded) {
                return
            }

            if (this.confirmed) {
                return
            }

            this.$emit('confirmed', this.lastDetected)
            this.confirmed = true
        },
    },
    mounted () {
        if (!this.$refs.video) {
            this.$emit('error', 'No video element')
            return
        }

        const vm = this
        Quagga.init({
            inputStream: {
                name: 'Live',
                type: 'LiveStream',
                target: this.$refs.video,
                constraints: {
                    facingMode: 'environment',
                },
            },
            decoder: {
                readers: [
                    // 'code_128_reader',
                    'ean_reader',
                    'ean_8_reader',
                    // 'code_39_reader',
                    // 'code_39_vin_reader',
                    // 'codabar_reader',
                    // 'upc_reader',
                    // 'upc_e_reader',
                    // 'i2of5_reader',
                    // '2of5_reader',
                    // 'code_93_reader',
                ],
            },
            locate: false,
            // locator: {
            //     patchSize: 'medium',
            //     halfSample: true,
            // },
            numOfWorkers: navigator.hardwareConcurrency || 4,
        }, function (err) {
            if (err) {
                console.error('Scanner init error', err)
                vm.$emit('error', err)
                try {
                    Quagga.stop()
                } catch {
                    // ignore
                }
                return
            }

            Quagga.start()
            Quagga.onDetected(vm.onDetected)
        })
    },
    beforeDestroy () {
        Quagga.stop()
        Quagga.offDetected(this.onDetected)
    },
}
</script>

<style>
    .barcode-scanner {
        background-color: #000;
        color: #fff;
    }

</style>
